<template>
    <el-table
		:header-cell-style="{background:'#f5f7fa',color:'#000'}"
        :data="tableData"
        border
        stripe
        style="width:100%"
        :row-style="{height:'50px'}"
        @selection-change="selectList">
        <!-- 是否开启多选checkbox -->
        <el-table-column 
        :selectEnable="selectEnable"
        v-if="selection" type="selection" align="center" fixed></el-table-column>
        <!-- 是否开启序号 -->
        <el-table-column v-if="indexs" type="index" align="center" label="序号" width="50"></el-table-column>
        <!-- prop: 字段名name, label: 展示的名称, fixed: 是否需要固定(left, right), minWidth: 设置列的最小宽度(不传默认值),
        btnList: 是否有操作列, btnList.name: 操作列字段名称, btnList.clickFun: 操作列点击事件, formatData: 格式化内容 -->
        <el-table-column v-for="(th, key) in tableHeader"
                        v-if="th.show?th.show:true"
                        :key="key"
                        :prop="th.prop"
                        :label="th.label"
                        :fixed="th.fixed"
                        :width="th.width"
                        :min-width="th.minWidth" 
                        :align="th.align">
            <!-- 加入template主要是有操作一栏， 操作一栏的内容是相同的， 数据不是动态获取的，这里操作一栏的名字定死（oper表示是操作这一列，否则就不是） -->
            <template slot-scope="scope">
				<!-- 操作栏目 -->
                <div class="controls" v-if="th.oper">
					<div v-for="(o, key) in th.oper" :style="th.style">
						<span 
						    v-if="o.formatData"
						    :key="key" @click="o.clickFun(scope.row)"
						    :style="o.style">
							{{scope.row[o.prop] || formatters(o.formatData)}}
						</span>
						<span 
						    v-else-if="o.limit"
						    :key="key" @click="o.clickFun(scope.row)"
						    :style="o.style">{{o.name}}
							
						</span>
						<span v-else :key="key" @click="o.clickFun(scope.row)"
							:style="o.style">{{o.name}}
						</span>
					</div>
                </div>
                <!--formatData：自定义过滤器-->
				<!-- 图片-->
                <img class="fengmian" v-if="th.prop=='sz_img'||th.prop == 'img'" 
				:src="scope.row[th.prop]||baseUrl+scope.row[th.prop]" alt="">
                <div v-else-if="th.formatData">
                    <div v-if="th.prop == 'titlesss'"
                        style="height:70px;line-height:22px;width:100%">
                        <p class="limit" style="font-weight:bold">{{scope.row.title}}</p>
                        <p class="limit">共{{scope.row.count.count}}篇内容</p>
                        <p class="limit">{{scope.row.introduct}}</p>
                    </div>
					<!-- 通知公告状态栏 -->
                    <div v-if="th.prop == 'gonggao' && $store.state.user.userinfo.flag!=3">
						<el-button type="success" size="mini">已读:{{scope.row.read}}</el-button>
						<el-button type="primary" size="mini">未读:{{scope.row.unread}}</el-button>
                    </div>
                    <div v-if="th.prop == 'gonggao'&&$store.state.user.userinfo.flag==3">
						<el-button type="success" v-if="scope.row.iscat==1" size="mini">已读</el-button>
						<el-button type="primary" v-else size="mini">未读</el-button>
                    </div>
					<!--工作汇报状态栏 -->
                    <div v-if="th.prop == 'huibao'">
						<el-button type="primary" size="mini" v-if="scope.row.iscat == 2">未读</el-button>
						<el-button type="success" size="mini" v-else>已读</el-button>
                    </div>
					<!--消息中心 -->
                    <div v-if="th.prop == 'message'">
						<el-button type="primary" size="mini" v-if="scope.row.iscat == 2">未读</el-button>
						<el-button type="success" size="mini" v-else>已读</el-button>
                    </div>
                    <span v-else class="limit">
                        {{scope.row[th.prop] | formatters(th.formatData)}}
                    </span>
                </div>
                <div v-else class="limit">
                    {{ scope.row[th.prop] }}
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>


<script>
    import props from './props.js'
    import { Message } from 'element-ui'
	import url_config from '@/axios/config.js'
    let that = this;
    export default{
        name:"tables",
        props:props,
		data(){
			return{
				baseUrl:url_config.baseUrl
			}
		},
        methods:{
            selectList(value){
                const arr = [];
                if(that.delkey){
                    value.forEach((item,key) => {
                        if( key = that.delkey){
                            arr.push(item[key])
                        }
                    })
                }else{
                    value.forEach((item,key) => {
                        arr.push(item)
                    })
                }
                that.$emit("selectList",arr);
            },
        },
        created(){that = this;},
        filters: {
            formatters (val, format) {
                if (typeof (format) === 'function') {
                  return format(val)
                } else return val
            }
        },
    }
</script>

<style scoped lang="scss">
    .limit{
        width: 100%;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .fengmian{
        width: 110px;
        height: 70px;
    }
	.controls{
		display: flex;
		align-items: center;
		justify-content: center;
		span{
			margin-right:5px;
			cursor:pointer;
			font-size:12px;
		}
	}
</style>


